
// Re-export the single Supabase client to avoid multiple GoTrueClient instances
import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || "https://qpfdqnenmjtnlffivuji.supabase.co";
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY || "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InFwZmRxbmVubWp0bmxmZml2dWppIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzM2MDYyNDEsImV4cCI6MjA4OTE4MjI0MX0.zWdqX8HH3a6qHBo5jvzpPZ2Z3t9XkzW-P48BXD9P-24";

// Single Supabase client instance for the entire application
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    storage: typeof globalThis !== 'undefined' ? globalThis.localStorage : undefined,
  },
});

// Flag to track if we're using mock mode - now always false since we're using real Supabase
export const isMockMode = false;

// Helper function to check if Supabase connection is working
export async function testSupabaseConnection(): Promise<boolean> {
  try {
    const { error } = await supabase.from('papers').select('id').limit(1);
    return !error;
  } catch (e) {
    console.error('Error testing Supabase connection:', e);
    return false;
  }
}
